import { render, staticRenderFns } from "./StickyNavBottom.vue?vue&type=template&id=38ab9018&scoped=true&"
import script from "./StickyNavBottom.vue?vue&type=script&lang=js&"
export * from "./StickyNavBottom.vue?vue&type=script&lang=js&"
import style0 from "./StickyNavBottom.vue?vue&type=style&index=0&id=38ab9018&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38ab9018",
  null
  
)

export default component.exports